import roundBetByStep from './roundBetByStep';
import findBetStep from './findBetStep';

export default function roundBet(bet: number): number {
    const betStep = findBetStep(bet);

    return roundBetByStep(bet, betStep);
}
